import React from 'react'
import { Button } from '@arvoreeducacao/bonsai-ds'
import Cdn from 'utils/assets/Cdn'
import { useUserInfo } from 'utils/hooks/use-userInfo'
import { useTranslation } from 'i18n'
import type { RedeemedAccessProps } from './RedeemedAccess.types'

const getFirstName = (name?: string): string =>
  name?.trim().split(/\s+/)[0] ?? ''

export const RedeemedAccess: React.FC<RedeemedAccessProps> = ({
  result,
  onStartReading,
  onLeave
}) => {
  const { t } = useTranslation()
  const { user } = useUserInfo()
  const startsNextYear = result.productYear > new Date().getUTCFullYear()
  const firstName = getFirstName(user?.name)
  const greeting = firstName ? `Pronto, ${firstName}!` : 'Pronto!'
  const status =
    result.status === 'already_redeemed'
      ? 'já estava liberado'
      : 'está liberado'

  const headline = startsNextYear
    ? t('Seu acesso de {{year}} está garantido', { year: result.productYear })
    : `Seu acesso de ${result.productYear} ${status}`

  return (
    <main className="w-full min-h-screen flex flex-col items-center justify-start px-4 py-20 bg-white md:py-[100px] md:px-10">
      <img
        src={Cdn.getImageUrl(
          'payment-page/payment-confirmation-celebration.svg'
        )}
        alt=""
        aria-hidden="true"
        className="w-full max-w-[343px] max-h-[160px] object-contain mb-6"
      />
      <h1 className="m-0 mb-4 max-w-[460px] text-center !text-[24px] font-bold leading-tight text-gray-900">
        {`${greeting} ${headline}`}
      </h1>
      <p className="m-0 mb-8 max-w-[460px] text-center !text-[16px] text-gray-700">
        {startsNextYear
          ? t(
              'Ele começa em 1º de janeiro de {{year}}. A partir desse dia é só entrar com o seu login. Não precisa digitar o código de novo.',
              { year: result.productYear }
            )
          : 'Suas leituras e sua Floresta continuam aqui.'}
      </p>
      <div className="w-full max-w-xs">
        {startsNextYear ? (
          <Button
            theme={{ type: 'ghost', size: 'xLarge' }}
            text={t('Sair')}
            onClick={onLeave}
            fluid
          />
        ) : (
          <Button
            theme={{ type: 'primaryLivros', size: 'xLarge' }}
            text={t('Começar a ler')}
            onClick={onStartReading}
            fluid
          />
        )}
      </div>
    </main>
  )
}
